import React from 'react';
import BaseAlert, { BaseAlertProps } from 'libs/core-components/Alert/BaseAlert';
import colors from 'settings/colors';
import styled from 'styled-components';
import InfoIcon from 'common/Icon/semantic/InfoIcon';

export const StyledInfoAlert = styled(BaseAlert)`
    background: ${colors.semantic.info};
    color: white;
`;

type InfoAlertProps = Omit<BaseAlertProps, 'icon'>;

export default function InfoAlert({ children, ...rest }: InfoAlertProps) {
    return (
        <StyledInfoAlert icon={<InfoIcon />} {...rest}>
            {children}
        </StyledInfoAlert>
    );
}
